import React from 'react'
import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { ArrowLeft16 } from '@makyoapp/makyo-icon/icon'

interface BackButtonProps {
  className?: string
  onClick?: () => void
  bottomBorder?: boolean
  label?: React.ReactNode
}
export function BackButton({ className, bottomBorder, onClick, label }: BackButtonProps) {
  return (
    <button
      className={clsx(
        'back flex items-center h-12 w-full text-start',
        className,
        'text-light hover:text-zinc-700 dark:hover:text-white transition-colors',
        bottomBorder && 'border-b bdr'
      )}
      onClick={onClick}
    >
      <div className='flex-cc w-12 h-12 shrink-0'>
        <ArrowLeft16 />
      </div>
      <div className='w-full'>{label ? label : <Trans>Back</Trans>}</div>
    </button>
  )
}
